import {RootState} from '../rootReducer';

export const userNotificationsSelector = (state: RootState) => state.notifications;
